import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage, setErrorPage } from '../../WifiManagementBlockSlice';
import { updateWifiSettingsAsync } from '../../WifiManagementBlockAsyncThunk';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { validateField } from '../../../../../utilities/validation/formValidation';
import infoIcon from './images/info-icon.svg';

const AddNetworkPage = (props) => {
    const [formData, setFormData] = useState();

    useEffect(() => {
        let formDataObj = {};

        for (let index = 0; index < props.optionalNetworks?.length; index++) {
            const element = props.optionalNetworks[index];

            formDataObj[element.name] = {
                name: { value: getDefaultNetworkName(element.name), error: '', validationRules: { required: true, requiredMessage: 'אנא הזן שם רשת', regexName: 'nameAndPasswordRegex', regexMessage: 'שם רשת לא תקין' } },
                password: { value: '', error: '', validationRules: { required: true, requiredMessage: 'אנא הזן סיסמא', regexName: 'nameAndPasswordRegex', regexMessage: 'סיסמא לא תקינה' } },
            }
        }

        setFormData(formDataObj);
    }, []);

    return (
        <div className='add-network-page'>

            <form noValidate id='form-add-network' onSubmit={(e)=> e.preventDefault()}>

                <div className='title'> הגדרת שם וסיסמת רשת אורחים </div>

                <div className='network-list-wrapper'>

                    {
                        formData &&
                        Object.keys(formData).map(function(item, index) {
                            return (
                                <div className='network-item' key={index}>
                                    <div className='network-type'> { getNetworkType(item) } </div>

                                    <div className='fields-wrapper'>
                                        <div className='row-wrapper'>
                                            <TextInput
                                                value={formData[item].name.value}
                                                error={formData[item].name.error}
                                                placeholder='שם הרשת'
                                                id='name'
                                                type='text'
                                                maxlength='30'
                                                autocomplete="off"
                                                onChange={(e) => handleOnChange(item, 'name', e.target.value)}
                                            />
                                        </div>
                                        <div className='row-wrapper'>
                                            <TextInput
                                                value={formData[item].password.value}
                                                error={formData[item].password.error}
                                                placeholder='הזן סיסמה'
                                                id='password'
                                                type='text'
                                                maxlength='50'
                                                autocomplete="off"
                                                onChange={(e) => handleOnChange(item, 'password', e.target.value)}
                                            />
                                        </div>
                                    </div>

                                </div>
                            );
                        })
                    }

                </div>

                <div className='bottom-remark-wrapper'>
                    <div className='icon-wrapper' style={{backgroundImage:infoIcon.bg()}}></div>
                    <div className='text-wrapper'> מומלץ להרכיב סיסמה שמורכבת מ8 ספרות לפחות או אותיות </div>
                </div>

                <div className='button-wrapper'>
                    <BtnSubmit text='שמירה' onclick={handleAddNetworkClick} formid='form-add-network' />
                </div>

            </form>

        </div>
    );


    function getNetworkType(frequency) {
        switch (frequency) {
            case '2.4GHZ': return '2.4 GHz Network';
            case '5GHZ': return '5 GHz Network';
            case '6GHZ': return 'wifi6 Network';
            default: return '';
        }
    }

    function getNetworkTypeFromFrequency(frequencyBand) {
        switch (frequencyBand) {
            case '2.4GHZ': return 'WIFIG2.4';
            case '5GHZ': return 'WIFIG5';
            case '6GHZ': return 'WIFIG6';
            default: return '';
        }
    }

    function getDefaultNetworkName(frequency) {
        return `${props.homeNetwork.networkName}_guest_${frequency.toLowerCase()}`;
    }


    function handleOnChange(item, fieldName, value) {
        let data = formData;
        const error = validateField(data[item][fieldName].validationRules, value);
        data[item][fieldName].error = error;
        data[item][fieldName].value = value;
        setFormData({ ...data });
    }

    function handleAddNetworkClick() {
        const isValid = validateAll();
        if (!isValid) { return; }
        handleSaveAll();
    }

    function validateAll() {
        let isValid = true;
        let data = formData;

        //validation
        Object.keys(formData).map(function(item, index) {
            const errorName = validateField(data[item]['name'].validationRules, data[item]['name'].value);
            data[item]['name'].error = errorName;
            setFormData({ ...data });

            const errorPassword = validateField(data[item]['password'].validationRules, data[item]['password'].value);
            data[item]['password'].error = errorPassword;
            setFormData({ ...data });

            if (errorName || errorPassword) {
                isValid = false;
            }
        });
        return isValid;
    }

    async function handleSaveAll() {
        const networkList = [];
        Object.keys(formData).map(function(item, index) {
            const network = {
                frequencyBand: item,
                networkEnable: true,
                networkName: formData[item]['name'].value,
                networkPass: formData[item]['password'].value,
                networkType: getNetworkTypeFromFrequency(item),
                type: 'Guest'
            }
            networkList.push(network);
        });

        const res = await props.updateWifiSettingsAsync({ isDisplayLoader: true, networkList: networkList });
        const isSuccess = res?.payload?.checkConnection?.isSuccess;

        if (isSuccess) {
            props.goToPage('guestNetworkPage');
        }
        else {
            props.setErrorPage('UPDATE_WIFI_DATA_ERROR');
        }
    }

};

const mapStateToProps = (state) => {
    return {
        homeNetwork: state.wifiManagementBlock?.networkWiFis.find(x=> x.type == 'Main'),
        optionalNetworks: state.wifiManagementBlock?.optionalNetworks.filter(x=> x.isChecked)
    };
};

const mapDispatchToProps = {
    goToPage,
    setErrorPage,
    updateWifiSettingsAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNetworkPage);
